let Regular={
  roleReg:/^[a-z]{1,20}$/,//新建角色编号正则
  nameReg:/^[\u4e00-\u9fa5A-Za-z0-9]{2,20}$/,//客户姓名
  phone:/^[1][0-9]{10}$/,//手机验证
  acont:/^[0-9a-zA-Z]{6,16}$/,//账号验证密码
  EngineerReg:/^\d{5}$/,//工程师编码
  longReg:/^[-+]?(0(.\d{1,10})?|(1-9?)(.\d{1,10})?|1[0-7]\d{1}(.\d{1,10})?|180.0{1,10})$/,//经度正则
  latReg:/^[-+]?((0|([1-8]\d?))(.\d{1,10})?|90(.0{1,10})?)$/,//纬度正则
  device:/^[a-zA-Z0-9]{9}$/,//摄像头设备序列号
  numberReg:/^[0-9]+.?[0-9]*/,//判断字符串是否为数字
  variable:/^[a-zA-z][a-zA-Z0-9_-]{0,31}$/,//点表变量名
  numPint:/^[+]{0,1}(\d+)$/,//判断正整数/^0|[1-9]\d*$/
  nunPintF:/^(0|[1-9][0-9]*|-[1-9][0-9]*)$/,//正负整数
  phonReg:/(^(0[0-9]{2,3})-([2-9][0-9]{6,7})(\\-[0-9]{1,4})?$)|(^(\\+0|\\+86)?(1[1-9][0-9]{9})$)|(^(400)-(\d{3})-(\d{4})(.)(\d{1,4})$)|(^(400)-(\d{3})-(\d{4})$)/,//手机或者座机
}
export default Regular
